import type { ReactNode } from 'react';
import { MoreHorizontal, Plus } from 'lucide-react';
import { Button } from '../ui/Button';
import { DropdownMenu } from '../ui/DropdownMenu';

export function LineTable({ columns, count, locked, addLabel, onAdd, onRemove, render }: {
  columns: string[];
  count: number;
  locked?: boolean;
  addLabel: string;
  onAdd: () => void;
  onRemove: (index: number) => void;
  render: (index: number) => ReactNode[];
}) {
  return (
    <div>
      <table className="bo-cards w-full text-sm">
        <thead>
          <tr className="text-left text-xs uppercase tracking-wide text-[var(--bo-faint)]">
            {columns.map((label) => <th key={label} className="px-2 py-2 font-medium">{label}</th>)}
            <th className="w-10" />
          </tr>
        </thead>
        <tbody>
          {Array.from({ length: count }, (_, index) => (
            <tr key={index} className="border-t border-[var(--bo-border)]">
              {render(index).map((cell, cellIndex) => <td key={cellIndex} className="px-2 py-2 align-middle" data-label={columns[cellIndex] || ''}>{cell}</td>)}
              <td className="px-2 py-2 text-right" data-label="">
                {locked ? null : (
                  <DropdownMenu
                    trigger={<button type="button" aria-label="Line actions" className="rounded-lg p-2 text-[var(--bo-muted)] hover:bg-[var(--bo-hover)]"><MoreHorizontal className="h-4 w-4" /></button>}
                    items={[{ label: 'Remove line', className: 'text-red-400', onClick: () => onRemove(index) }]}
                  />
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      {locked ? null : <Button className="mt-3" variant="outline" onClick={onAdd}><Plus className="mr-2 h-4 w-4" />{addLabel}</Button>}
    </div>
  );
}
